import "./logout-warning-modal.styles.css";

const LogoutWarningModal =({ countdown, onStayLoggedIn })=> {
  return (
    <div className="logout-warning-modal-wrapper">

    <div className="logout-warning-modal">
      <p>⚠️ You’ll be logged out in <strong>{countdown}</strong> seconds due to inactivity.</p>
      <button className="btn btn-danger" onClick={onStayLoggedIn}>Stay Logged In</button>
    </div>
    </div>
  );
}

export default LogoutWarningModal;
